import React, { useState, useEffect, useCallback, useContext,useMemo } from "react";
import Table from "../UI/Table";
import { Link } from "react-router-dom";
import { Image } from "../UI/Image";
import './QuoteNotification.css';
import { AlertTriangle, Calendar,Check } from "react-feather";
import AppContext from "../../store/app-context";

const QuoteNotification=()=>{
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);  
  const [error, setError] = useState(null);
  const appCtx = useContext(AppContext);
  // Add translation
  const defaults = {
    notifications_viewall:'View all notifications',
    notifications_approved_quote_text:'Approved quote expiring soon',
    notifications_expired_quote_text:'Quote expired',
    notifications_recent: 'Recent notifications',
    notification_view_quote: 'View Quote',
    notifications_type: 'Type',
    notifications_status: 'Status',
    notifications_date: 'Date',
    notifications_quote:'Quote',
    notification_resubmit_quote: 'Resubmit',
    notification_expired_on:'Expired on',
    notifications_quote_id:'Quote ID',
    notification_today:'Today',
    notification_yesterday:'Yesterday',
    notification_expires_on:'Expires on',
    notifications_quoteapproved_quote_text:'Quote approved',
  };
  
  let {
    notifications_viewall,
    notifications_approved_quote_text,
    notifications_expired_quote_text,
    notifications_recent,
    notification_view_quote,
    notifications_type,
    notifications_status,
    notifications_date,
    notifications_quote,
    notification_resubmit_quote,
    notification_expired_on,
    notifications_quote_id,
    notification_today,
    notification_yesterday,
    notification_expires_on,
    notifications_quoteapproved_quote_text
  } = defaults;
  if (appCtx && appCtx.bioradResources) {
    notifications_viewall = appCtx.bioradResources.notifications_viewall ? appCtx.bioradResources.notifications_viewall : notifications_viewall;

    notifications_approved_quote_text = appCtx.bioradResources.notifications_approved_quote_text ? appCtx.bioradResources.notifications_approved_quote_text : notifications_approved_quote_text;

    notifications_expired_quote_text = appCtx.bioradResources.notifications_expired_quote_text ? appCtx.bioradResources.notifications_expired_quote_text : notifications_expired_quote_text;

    notifications_recent = appCtx.bioradResources.notifications_recent ? appCtx.bioradResources.notifications_recent : notifications_recent;

    notification_view_quote = appCtx.bioradResources.notification_view_quote ? appCtx.bioradResources.notification_view_quote : notification_view_quote;

    notifications_type = appCtx.bioradResources.notifications_type ? appCtx.bioradResources.notifications_type : notifications_type;

    notifications_status = appCtx.bioradResources.notifications_status ? appCtx.bioradResources.notifications_status : notifications_status;

    notifications_date = appCtx.bioradResources.notifications_date ? appCtx.bioradResources.notifications_date : notifications_date;

    notification_resubmit_quote = appCtx.bioradResources.notification_resubmit_quote ? appCtx.bioradResources.notification_resubmit_quote : notification_resubmit_quote;

    notification_expired_on = appCtx.bioradResources.notification_expired_on ? appCtx.bioradResources.notification_expired_on : notification_expired_on;

    notifications_quote_id = appCtx.bioradResources.notifications_quote_id ? appCtx.bioradResources.notifications_quote_id : notifications_quote_id;

    notification_expires_on = appCtx.bioradResources.notification_expires_on ? appCtx.bioradResources.notification_expires_on : notification_expires_on;

    notifications_quote = appCtx.bioradResources.notifications_quote ? appCtx.bioradResources.notifications_quote : notifications_quote;

    notification_yesterday = appCtx.bioradResources.notification_yesterday ? appCtx.bioradResources.notification_yesterday : notification_yesterday;

    notification_today = appCtx.bioradResources.notification_today ? appCtx.bioradResources.notification_today : notification_today;

    notifications_quoteapproved_quote_text = appCtx.bioradResources.notifications_quoteapproved_quote_text ? appCtx.bioradResources.notifications_quoteapproved_quote_text : notifications_quoteapproved_quote_text;
  }  
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const url = '/etlapi/my-biorad/notifications/quote'
        const res = await fetch(url)
        let data=await res.json()
        setData(data?.listNotifications); 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false); 
      }
    };

    fetchUsers();
  }, []); 
  const formatDate = (isoString) => {
  if(isoString!=''){
  if(isoString.toLowerCase()=='yesterday'){
    return notification_yesterday
  }
  if(isoString.toLowerCase()=='today'){
    return notification_today
  }
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // JS months are 0-based
  const year = date.getFullYear();
  return isoString
}
}
  const handleActionClick = useCallback((type, text, id,e) => {
    e.stopPropagation();
    // e.preventDefault();
    window.digitalData = window.digitalData || []
    window.digitalData.push({ 
      event: 'notificationCTAClick', 
      attributes: { 
        notificationType: type,
        notificationText: text,
        entityid: id
      }
    });  
  }, []); 
  

  function flattenObject(obj, parentKey = "", result = {}) {
  for (let key in obj) {
    let value = obj[key];
    const propName = parentKey ? `${parentKey}.${key}` : key;

    // Try to parse stringified JSON safely
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        if (typeof parsed === "object" && parsed !== null) {
          flattenObject(parsed, propName, result);
          continue;
        }
      } catch (_) {
        // Not JSON, keep as is
      }
    }

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      flattenObject(value, propName, result);
    } else {
      result[propName] = value;
    }
  }
  return result;
}
  const columns = useMemo(() => [
  { header:notifications_type, accessor: "entityType", render: (_, row) => { return <span>{notifications_quote}</span> } },
  {
    header: notifications_status,
    accessor: "payload.quoteType",
    render: (_, row) => {
      const status = row["payload.quoteType"]?.toLowerCase()
      switch (status) {
        case "expired":
          return <><div className="icon-text-css"><span className="icon-circle red">
            <AlertTriangle height={24} width={24} />
            </span><span>{notifications_expired_quote_text}</span>
            
            </div>
            <div className="Quote-info"> 
              {row["payload.quoteId"] && notifications_quote_id }{" "}
              {[
                row["payload.quoteId"],
                row["formatedTotal"]
              ].filter(Boolean).join(", ")}
            </div>
            {row["formattedExpiredDate"]?<div className="Expiry-date"> {notification_expired_on} {formatDate(row["formattedExpiredDate"])}</div>:''}</>
        case "expiring":
          return <><div className="icon-text-css"><span className="icon-circle orange">
            <Calendar height={24} width={24} />
           </span><span>{notifications_approved_quote_text}</span></div>
          <div className="Quote-info">
          {row["payload.quoteId"] && notifications_quote_id }{" "}
            {[
              row["payload.quoteId"],
              row["formatedTotal"]
            ].filter(Boolean).join(", ")}
          </div>
          {row["formattedExpiredDate"]?<div className="Expiry-date">{notification_expires_on} {formatDate(row["formattedExpiredDate"])}</div>:''}
          </> 
        case "approved":
          return <><div className="icon-text-css"><span className="icon-circle green">
            <Check height={24} width={24} />
           </span><span>{notifications_quoteapproved_quote_text}</span></div>
          <div className="Quote-info">
          {row["payload.quoteId"] && notifications_quote_id }{" "}
            {[
              row["payload.quoteId"],
              row["formatedTotal"]
            ].filter(Boolean).join(", ")}
          </div>
          </> 
        default:
          return <><span className="status-icon">{row.statusIcon}</span>{status}</>
      }
    }
  },
  { header: notifications_date, accessor: "formattedUpdateDate",render: (_, row) => {return <div>{row.formattedUpdateDate?formatDate(row.formattedUpdateDate):''}</div>} },
  {
    header: "",
    accessor: "action",
    render: (_, row) => {
      const status = row["payload.quoteType"]?.toLowerCase()
      switch (status) {
        case "expired":
          return <Link to={`/quotes/`+row["payload.webReferenceId"]} className="action-btn gray" onClick={(e) => handleActionClick("Quote", 'Quote expired', row.entityId,e)}>{notification_resubmit_quote}</Link>
        case "expiring":
          return <Link to={`/quotes/`+row["payload.webReferenceId"]} className="action-btn gray" onClick={(e) => handleActionClick("Quote", 'Approved quote expiring soon', row.entityId,e)}>{notification_view_quote}</Link>
        case "approved":
          return <Link to={`/quotes/`+row["payload.webReferenceId"]} className="action-btn gray" onClick={(e) => handleActionClick("Quote", 'Quote approved', row.entityId,e)}>{notification_view_quote}</Link>
        default:
          return <Link className="action-btn gray">Unknown</Link>
      }
    }
  }
], [appCtx]);

  const flattenedData = data?.slice(0, 5)?.map(item => flattenObject(item));
  return (
    loading?<p className="loading_ring"></p>:
    flattenedData?.length>0?<><div className="recent-notification">{notifications_recent}</div><div className="notification-container">
      <Table data={flattenedData} columns={columns} />
      <a href="/bc/en-us/my-biorad/my-notifications" className="view-all">{notifications_viewall}</a>
    </div></>:''
  );
}

export default QuoteNotification;
